import React, { createContext, useState, useContext } from "react";

const EnunciadoContext = createContext();

export default function AmbienteProvider({ children }) {
  const [enunciado, setEnunciado] = useState();

  return (
    <EnunciadoContext.Provider value={{ enunciado, setEnunciado }} >
      {children}
    </EnunciadoContext.Provider>
  );
}

export function useEnunciadoContext() {
  const context = useContext(EnunciadoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { enunciado, setEnunciado } = context;
  return { enunciado, setEnunciado };
}

